import { Component, ViewEncapsulation } from '@angular/core';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { MemberInformationService } from '../member-information.service';
import { DumbMemberNewsArticle } from '../DTOs/dumb-member-news-article';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { MemberNewsArticleDetails } from '../DTOs/member-news-article-details';
import { CommonLibrary } from '../../../core/common-library';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-member-news-article',
  templateUrl: './member-news-article.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})

export class MemberNewsArticleComponent {

  constructor(private memberInformationService: MemberInformationService
    , private blockUI: UIBlockingService
    , private route: ActivatedRoute
      , private notificationService: ToastNotificationService
    , private sanitizer: DomSanitizer) {
  }
    protected readonly CommonLibrary = CommonLibrary;
  articleId: string;
  article: MemberNewsArticleDetails = new MemberNewsArticleDetails();
    additionalArticles: DumbMemberNewsArticle[] = [];
    safeArticleContent: SafeHtml

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.blockUI.start();
            this.articleId = params['articleId'];
            this.getArticleDetails();
        });
  }


    getArticleDetails() {
    this.blockUI.start();
    this.memberInformationService.GetNewsArticleDetails(this.articleId)
      .subscribe(
        {
          next: (data) => {
            this.article = data;
            this.additionalArticles = data.additionalArticles;
            this.safeArticleContent = this.sanitizer.bypassSecurityTrustHtml(data.contentFull)
            this.blockUI.stop();
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

    DownloadAttachment(ind) {
        CommonLibrary.downloadImageByUrl(this.article.attachments[ind].downloadUrl, this.article.attachments[ind].name.split('.')[0])
    }




}
